import { Dialog } from "@mui/material";
import { COLORS } from "screens/perfilAutonomo/utils";
import styled from "styled-components";

export const DialogContainer = styled(Dialog)`
  .MuiDialog-paper {
    border-radius: 12px;
  }
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: 20px;
  box-sizing: border-box;
  font-family: Inter;
  gap: 12px;

  .title {
    font-size: 18px;
    font-weight: 600;
    color: ${COLORS.gray500};
    text-align: flex-start;
    width: 100%;
    margin-left: 10px;
  }
  .center {
    align-self: center;
  }
  .subtitle {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    color: ${COLORS.gray300};
  }
  .error-text {
    margin-top: 5px;
    font-size: 12px;
    color: red;
  }
`;

export const IconContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 5px;
  gap: 10px;

  .icon-wrapper {
    background-color: #d1fadf;
    border-radius: 50%;
    border: 8px solid #ecfdf3;
    padding: 8px;
    font-size: 20px;
  }
  .exit {
    color: #667085;
    :hover {
      cursor: pointer;
    }
  }
`;

export const WarningContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 10px;
  box-sizing: border-box;
  p {
    font-size: 16px;
    color: ${COLORS.error500};
    font-weight: 500;
    font-family: Inter;
  }
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  background-color: #f7f7f7;
  border-radius: 16px;
  padding: 20px;
  box-sizing: border-box;
`;

export const FlexRow = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  gap: 20px;
  width: 100%;
`;

export const Row = styled.div<{ template?: string }>`
  display: grid;
  grid-template-columns: ${({ template }) => template ?? "1fr 1fr"};
  grid-gap: 20px;
  align-items: center;
  width: 100%;
`;

export const Info = styled.div`
  display: flex;
  flex-direction: column;
  align-self: flex-start;
  gap: 6px;
  font-family: Inter;
  font-weight: 500;
  h3 {
    font-size: 14px;
    color: #475467;
  }
  p {
    font-size: 16px;
    color: black;
    line-height: normal;
  }
`;
